import React from "react";

import {Themed} from '@/theme'

const Sidebar = () => {
  return <Themed component="Sidebar"  />
};

export default Sidebar